export default {"src":"/spot-fe-premarket/_next/static/media/5.7b5dfa70.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};